export default "__VITE_ASSET__Wf8GjcRj__"